import { Suspense } from 'react';
import { Route } from 'react-router-dom';
import AppLayout from '@/components/AppLayout';
import ErrorBoundary from '@/components/ErrorBoundary';
import ProtectedRoute from '@/components/ProtectedRoute';
import RoleGuard from '@/components/RoleGuard';
import { LoadingSpinner } from '@/app/LoadingSpinner';
import { P } from '@/app/guards';
import {
  CatalogueIntegration,
  CloturesZ,
  CommandesWeb,
  JournalFiscal,
  MonCompte,
  MyPOSClientConfig,
  MyPOSStaffConfig,
  NF525Dashboard,
  ParametresWeb,
  PrintersConfig,
  MonnayeurConfig,
  BalanceConfig,
  QuickLogin,
  RapportFiscal,
  StaffBadges,
  TransactionsCB,
  TransactionsCBExternes,
  Tutoriels,
} from '@/app/lazyPages';

/**
 * Groupe de routes extrait d'App.tsx (strangler 1b) — ordre source préservé.
 * Table de routes déclarative : dépasse volontairement max-lines-per-function (warn).
 */
export function fiscalMiscRoutes() {
  return (
    <>
      <Route
        path="/commandes-web"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <CommandesWeb />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/parametres-web"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <ParametresWeb />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/tutoriels"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <Tutoriels />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/clotures-z"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <CloturesZ />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/journal-fiscal"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <JournalFiscal />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/mon-compte"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <MonCompte />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/transactions-cb"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <TransactionsCB />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/transactions-cb-externes"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <TransactionsCBExternes />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/paiements-mypos"
        element={
          <ProtectedRoute>
            <AppLayout>
              <Suspense fallback={<LoadingSpinner />}>
                <MyPOSClientConfig />
              </Suspense>
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/conformite-nf525"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <NF525Dashboard />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/rapport-fiscal"
        element={
          <P>
            <RoleGuard roles={['super_admin', 'admin']}>
              <Suspense fallback={<LoadingSpinner />}>
                <RapportFiscal />
              </Suspense>
            </RoleGuard>
          </P>
        }
      />
      <Route
        path="/imprimantes"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <PrintersConfig />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/monnayeur"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <MonnayeurConfig />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/balance"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <BalanceConfig />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/mypos-staff-config"
        element={
          <ProtectedRoute>
            <AppLayout>
              <Suspense fallback={<LoadingSpinner />}>
                <MyPOSStaffConfig />
              </Suspense>
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/badges-nfc"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <StaffBadges />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/quick-login"
        element={
          <Suspense fallback={<LoadingSpinner />}>
            <QuickLogin />
          </Suspense>
        }
      />
      <Route
        path="/catalogue-integration"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <CatalogueIntegration />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
    </>
  );
}
